import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor( public loginService: LoginService ) { }

  ngOnInit ( ) { }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/footer/footer.component.ts